import { FC, ReactNode } from 'react';
import { useLocation } from 'react-router-dom';

// project imports
import { useAuthContext } from '@/providers';
import { isModeratorPathAllowed, isNeighborhoodModerator } from '@/providers/auth';
import { AccessDeniedModal } from './AccessDeniedModal';
import { PermissionMode, useHasPermission } from './use-has-permission';

// ==============================|| PERMISSION GATE (route-level) ||============================== //

interface Props {
	permission: string | string[];
	mode?: PermissionMode;
	children: ReactNode;
}

/**
 * Wraps a routed page. If the user holds the required permission(s) the page is
 * rendered; otherwise the page is replaced by the access-restricted modal (the
 * surrounding layout — sidebar/header — stays visible behind it).
 *
 * Moderatorul de cartier nu deține permisiunile de staff ale paginii cartierului (ex.
 * `neighborhoods:read`): pentru el decide regula rutelor de moderator — pagina cartierului lui,
 * conținutul pentru care are drept și profilul. BE-ul limitează oricum fiecare apel.
 */
export const PermissionGate: FC<Props> = ({ permission, mode = 'all', children }) => {
	const allowed = useHasPermission(permission, mode);
	const { user } = useAuthContext();
	const { pathname } = useLocation();
	const moderatorAllowed =
		isNeighborhoodModerator(user) && isModeratorPathAllowed(user, pathname);
	if (allowed || moderatorAllowed) return <>{children}</>;
	return <AccessDeniedModal open />;
};
